import React, { useEffect, useState } from 'react';
import ToggleButton from './ToggleButton';

function ScoreField({ studentId, score, maxScore, onScoreChange, isBinary }) {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(score ?? null);

  useEffect(() => {
    // Keep local value in sync when score prop changes
    setInputValue(score ?? null);
  }, [score]);

  const handleFocus = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    // For numeric comparison, normalize types; allow saving 0 as valid score
    const prev = score === undefined || score === null ? null : Number(score);
    const next = inputValue === undefined || inputValue === null ? null : Number(inputValue);
    if (prev !== next) {
      onScoreChange(studentId, next);
    }
  };

  const handleChange = (e) => {
    const raw = e.target.value;
    const numeric = raw === '' ? null : Number(raw);
    if (numeric === null) {
      setInputValue(null);
      return;
    }
    if (numeric < 0) {
      setInputValue(0);
      return;
    }
    if (numeric > maxScore) {
      setInputValue(maxScore);
      return;
    }
    setInputValue(numeric);
  };

  return (
    <div className="score-field" >
      {isEditing ? 
      (!isBinary && (
        <input
          type="number"
          value={inputValue ?? ''}
          onChange={handleChange}
          onBlur={handleBlur}
          autoFocus
          className="score-input"
          max={maxScore}
        /> 
      )): (
        !isBinary ? (
        <span
          className="score-display"
          onClick={handleFocus}
          style={{ color: (score !== null && score !== undefined) ? '#4CAF50' : '#000'}}
        >
          {(score !== null && score !== undefined) ? `${score} / ${maxScore}` : ` / ${maxScore}`}
        </span>): ( <><ToggleButton
        value={inputValue == null ? null : Number(inputValue)}
        setScore={(v) => setInputValue(v)}
        onBlur={handleBlur}
      />
    </>)
      )}
    </div>
  );
}

export default ScoreField;
